import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function TrafficCalmingZonesLegendIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 0 12 H 24",
    stroke: "#03825c",
    strokeDasharray: "2, 2",
    strokeWidth: "2"
  }));
}